class BackToTop extends HTMLElement {
    constructor() {
        super()

        window.addEventListener("scroll", (e) => {
            this.toggleShow()
        })

        window.onload = () => {
            this.toggleShow();
            this.bottomabarCheck();
        }

        this.onload = (e) => {
            this.toggleShow();
            this.bottomabarCheck();
        }

        this.onclick = (e) => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    }

    bottomabarCheck = () => {
        const mql = window.matchMedia('(max-width: 750px)');
        const bottomBar = document.body.querySelector('#mobile_nav');
        const backTop = this.querySelector('#ml_back_to_top');
        if(mql.matches && !bottomBar && backTop) {
            backTop.style.setProperty('--back_top_offset-y', `${this.dataset.offset}px`)
        }
    }

    toggleShow = () => {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          this.style.opacity = 1;
          this.style.visibility = "visible";
        } else {
          this.style.opacity = 0;
          this.style.visibility = "hidden";
        }
    }
}

customElements.define('back-to-top', BackToTop);